import { useEffect, useState } from 'react';
import axios from 'axios';
import { URL } from 'appConstants';

export interface Document {
  id: number;
  slug: string;
  title: string;
  description: string;
  short_description?: string;
  file: string;
  file_url: string;
  file_size_display?: string;
  file_type?: string;
  uploaded_at?: string;
  category?: number;
  category_name?: string;
}

export interface CategoryGroup {
  categoryId: number;
  categoryName: string;
  documents: Document[];
}

export const useDocuments = () => {
  const [documents, setDocuments] = useState<Document[]>([]);
  const [groupedDocuments, setGroupedDocuments] = useState<CategoryGroup[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    setLoading(true);
    axios.get<Document[]>(URL.DOCUMENTS.GET)
      .then((res) => {
        setDocuments(res.data);
        // axios.get<Document[]>('http://localhost:8000/api/documents/document/')
        //   .then((res) => {
        //     setDocuments(res.data);
        // Группируем документы по категориям
        const groups: { [key: number]: CategoryGroup } = {};

        res.data.forEach((doc) => {
          const catId = doc.category || 0;
          const catName = doc.category_name || 'Без категории';

          if (!groups[catId]) {
            groups[catId] = {
              categoryId: catId,
              categoryName: catName,
              documents: [],
            };
          }

          groups[catId].documents.push(doc);
        });

        // Преобразуем объект в массив и сортируем
        const groupedArray = Object.values(groups)
          .sort((a, b) => a.categoryName.localeCompare(b.categoryName));

        setGroupedDocuments(groupedArray);
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return {
    documents,
    groupedDocuments,
    loading,
    error,
  };
};
